export default __webpack_public_path__ + "static/media/settle-4.370d4fe5.png";